import {rupiah} from 'utils/formatter'
import styles from './Gratuity.css'

class Gratuity extends React.Component {
  render () {
    let {paymentGratuities, includeGratuityTax} = this.props

    return (paymentGratuities.length > 0 && <div className='row'>
      <div className='col-md-12'>
        <label>Gratuity</label>
        <table className='table mk-table-summary table-truncate'>
          <tbody>
            {paymentGratuities.map((gratuity, idxdisc) => (<tr key={idxdisc}>
              <td width='70%' className='name-item-refund tax-grat-disc' style={{border: 'none !important'}}>
                { gratuity.name } {includeGratuityTax && '(Included)'}
              </td>
              <td width='30%' className={'text-right price text-gray ' + styles['grat-price']} style={{border: 'none !important'}}>
                { !includeGratuityTax && rupiah(this._calculateGratuity(gratuity.id))}
              </td>
            </tr>))}
          </tbody>
        </table>
      </div>
    </div>)
  }

  _calculateGratuity = (gratuityId) => {
    return this.props.calculateGratuity(gratuityId)
  }
}

Gratuity.propTypes = {
  paymentGratuities: React.PropTypes.array,
  includeGratuityTax: React.PropTypes.bool,
  // calculateGratuity(gratuity_id)
  calculateGratuity: React.PropTypes.func
}

export default Gratuity



// WEBPACK FOOTER //
// ./app/components/receipt/refunds/RefundBreakdownModal/Gratuity/Gratuity.js